import axios from 'axios';
import router from '@/router';
import store from '@/store';

// axios.defaults.baseURL = process.env.VUE_APP_API_URL;
axios.defaults.baseURL = process.env.VUE_APP_RAM_API_URL;
axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.interceptors.response.use((response: any) => {
    response.headers["X-Frame-Options"] = "SAMEORIGIN";
    return response;
}, (error: any) => {
    if (typeof error.response !== 'undefined' && error.response.status === 401) {
        store.commit('auth/setToken', '');
        store.commit('auth/setUsername', '');
        store.commit('auth/setName', '');
        store.commit('auth/setRole', '');

        axios.defaults.headers.common.Authorization = '';

        router.push({
            name: 'Login',
            params: {
                error: 'Your session has expired. Please login.',
            },
        });
    }

    throw error;
});


// export {genericapiinstance,axios};
export default axios;
